import "./FloatingYearFilter.scss"
import React from "react";
import {queryStringToObject} from "../../util/url";
import {useYearFilterState} from "../../store/YearFilterState";
import {IconHouses} from "../../icons";

export function FloatingYearFilter() {

  const filter = useYearFilterState()
  // const currentYear = (new Date()).getFullYear()
  const qso: { year: string } = queryStringToObject(window.location.href)
  const qsoy = qso.year?qso.year.startsWith("[")?JSON.parse(qso.year):JSON.parse(`[${qso.year}]`):"[]";
  let qsoyear: (string | number)[] = []
  if (qso.year && Array.isArray(qsoy)) {
    qsoyear = qsoy
  }
  const filterSet = qsoyear.length > 0

  const bi = qsoyear.indexOf(2000)
  if(bi >= 0) qsoyear[bi] = "Введені"

  const openFIlterDrawer = () => {
    filter.openDrawer()
  }

  return <>
    <div className="filter-status" onClick={openFIlterDrawer}>
      <span><IconHouses color={filterSet ? "black" : "silver"}/></span>
      {/*<icon-houses style={{color: filterSet ? "black" : "silver"}}></icon-houses>*/}
      <label>{qsoyear.length ? qsoyear.join(', ') : "Всі"} р. побудови</label>
    </div>
  </>
}